'use client';

import {useId} from 'react';
import {Input} from '@/matic/components/ui/input';

type NumberFieldProps = {
  value: unknown;
  onChange: (value: number | null) => void;
  error?: string;
  disabled?: boolean;
  label: string;
  required?: boolean;
};

export function NumberField({
  value,
  onChange,
  error,
  disabled,
  label,
  required,
}: NumberFieldProps) {
  const id = useId();
  const numValue =
    typeof value === 'number' ? value : value ? Number(value) : '';
  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1 block text-sm font-medium text-gray-700"
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      <Input
        id={id}
        type="number"
        value={numValue === '' ? '' : String(numValue)}
        onChange={(e) => {
          onChange(e.target.value === '' ? null : Number(e.target.value));
        }}
        disabled={disabled}
        className={error ? 'border-red-500' : ''}
      />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
